export var LOCALE = "en-EN";
export var DEFAULT_INVESTMENT_CURRENCY = "EUR";
